export default __webpack_public_path__ + "static/media/tick-white-bold.37c3b4f5.svg";